import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { ExpectedTransactionType } from '@dealstack/shared/lib/generated';

export enum TRANSACTION_TYPE_BULK_FORM_FIELD {
	expectedTransactionType = 'expectedTransactionType',
}

export const TransactionTypeBulkShape = z.object({
	expectedTransactionType: z.nativeEnum(ExpectedTransactionType).nullable(),
});

export type TransactionTypeBulkFormDto = z.infer<typeof TransactionTypeBulkShape>;

export const useTransactionTypeBulkDrawerController = (opened: boolean) => {
	const transactionTypeBulkForm = useForm<TransactionTypeBulkFormDto>({
		mode: 'all',
		resolver: zodResolver(TransactionTypeBulkShape),
		defaultValues: { expectedTransactionType: null },
		shouldFocusError: false,
	});

	const { reset } = transactionTypeBulkForm;

	useEffect(() => {
		if (opened) {
			reset({ expectedTransactionType: null });
		}
	}, [opened, reset]);

	return { transactionTypeBulkForm };
};
